import '../../assets/index4.css';var C = Object.defineProperty, I = Object.defineProperties;
var g = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var b = Object.prototype.hasOwnProperty, F = Object.prototype.propertyIsEnumerable;
var _ = (e, n, t) => n in e ? C(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, u = (e, n) => {
  for (var t in n || (n = {}))
    b.call(n, t) && _(e, t, n[t]);
  if (s)
    for (var t of s(n))
      F.call(n, t) && _(e, t, n[t]);
  return e;
}, h = (e, n) => I(e, g(n));
var f = (e, n) => {
  var t = {};
  for (var c in e)
    b.call(e, c) && n.indexOf(c) < 0 && (t[c] = e[c]);
  if (e != null && s)
    for (var c of s(e))
      n.indexOf(c) < 0 && F.call(e, c) && (t[c] = e[c]);
  return t;
};
import { jsx as o, jsxs as m } from "react/jsx-runtime";
import { forwardRef as A } from "react";
import { PlusFarFAIcon as N, FileTextFarFAIcon as w, EnvelopeFarFAIcon as L, CommentFarFAIcon as S, ReceiptFarFAIcon as B, MagnifyingGlassFarFAIcon as T, SparklesFarFAIcon as x, HomeFarFAIcon as y, UserCircleFarFAIcon as R, EnvelopeOpenFarFAIcon as H, LocationFarFAIcon as U, FolderFarFAIcon as W } from "../../components/Icons/index.js";
import { Menu as i } from "../../components/Menu/index.js";
import { B as D } from "../../factory-ueRxoNOV.js";
import { S as E } from "../../Stack-CTaaXTID.js";
import { L as k } from "../../chunk-KNED5TY2-CXwb6gAr.js";
import { U as M } from "../../UnstyledButton-D9OCzDhz.js";
import { T as O } from "../../Text-B7Ta53Id.js";
const j = "Sidebar-module__root___CfdOv", G = "Sidebar-module__content___PGSUp", P = "Sidebar-module__navItem___uJR2r", Q = "Sidebar-module__iconWrapper___i33c-", $ = "Sidebar-module__navItemLabel___MpF7d", J = "Sidebar-module__newButton___Q6Lv6", l = {
  root: j,
  content: G,
  navItem: P,
  iconWrapper: Q,
  navItemLabel: $,
  newButton: J
}, a = ({ icon: e, label: n, active: t, onClick: c, className: d }) => /* @__PURE__ */ m(
  M,
  {
    className: `${l.navItem} ${d || ""}`,
    "data-active": t,
    onClick: c,
    children: [
      /* @__PURE__ */ o("div", { className: l.iconWrapper, children: e }),
      /* @__PURE__ */ o(O, { className: l.navItemLabel, children: n })
    ]
  }
), q = A((d, c) => {
  var p = d, {
    activeItem: e = "home",
    onItemClick: n
  } = p, t = f(p, [
    "activeItem",
    "onItemClick"
  ]);
  const r = (v) => {
    n == null || n(v);
  };
  return /* @__PURE__ */ o(
    D,
    h(u({
      ref: c,
      className: l.root
    }, t), {
      children: /* @__PURE__ */ m(E, { className: l.content, children: [
        /* @__PURE__ */ m(i, { children: [
          /* @__PURE__ */ o(i.Target, { children: /* @__PURE__ */ o(
            a,
            {
              className: l.newButton,
              icon: /* @__PURE__ */ o(N, {}),
              label: "New",
              active: e === "new"
            }
          ) }),
          /* @__PURE__ */ m(i.Dropdown, { children: [
            /* @__PURE__ */ o(
              i.Item,
              {
                leftSection: /* @__PURE__ */ o(w, {}),
                onClick: () => r("interaction"),
                children: "Interaction"
              }
            ),
            /* @__PURE__ */ o(
              i.Item,
              {
                leftSection: /* @__PURE__ */ o(L, {}),
                onClick: () => r("email"),
                children: "Email"
              }
            ),
            /* @__PURE__ */ o(
              i.Item,
              {
                leftSection: /* @__PURE__ */ o(S, {}),
                onClick: () => r("text"),
                children: "Text"
              }
            ),
            /* @__PURE__ */ o(
              i.Item,
              {
                leftSection: /* @__PURE__ */ o(B, {}),
                onClick: () => r("text"),
                children: "Receipt"
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ o(k, { to: "/QuorumSearch", style: { textDecoration: "none" }, children: /* @__PURE__ */ o(
          a,
          {
            icon: /* @__PURE__ */ o(T, {}),
            label: "Search",
            onClick: () => r("search"),
            active: e === "search"
          }
        ) }),
        /* @__PURE__ */ o(k, { to: "/CopilotHub", style: { textDecoration: "none" }, children: /* @__PURE__ */ o(
          a,
          {
            icon: e === "copilothub" ? /* @__PURE__ */ o(x, { filled: !0 }) : /* @__PURE__ */ o(x, {}),
            label: "Copilot Hub",
            onClick: () => r("copilothub"),
            active: e === "copilothub"
          }
        ) }),
        /* @__PURE__ */ o(
          a,
          {
            icon: /* @__PURE__ */ o(y, {}),
            label: "Home",
            onClick: () => r("home"),
            active: e === "home"
          }
        ),
        /* @__PURE__ */ o(
          a,
          {
            icon: /* @__PURE__ */ o(R, {}),
            label: "Contacts",
            onClick: () => r("contacts"),
            active: e === "contacts"
          }
        ),
        /* @__PURE__ */ o(
          a,
          {
            icon: /* @__PURE__ */ o(H, {}),
            label: "Outbox",
            onClick: () => r("outbox"),
            active: e === "outbox"
          }
        ),
        /* @__PURE__ */ o(
          a,
          {
            icon: /* @__PURE__ */ o(U, {}),
            label: "Tracking",
            onClick: () => r("tracking"),
            active: e === "tracking"
          }
        ),
        /* @__PURE__ */ o(
          a,
          {
            icon: /* @__PURE__ */ o(W, {}),
            label: "Reporting",
            onClick: () => r("reporting"),
            active: e === "reporting"
          }
        ),
        /* @__PURE__ */ o(
          a,
          {
            icon: /* @__PURE__ */ o(S, {}),
            label: "Texting",
            onClick: () => r("texting"),
            active: e === "texting"
          }
        )
      ] })
    })
  );
});
q.displayName = "Sidebar";
export {
  q as Sidebar
};
